<template>
  <!-- 轮番图模块 -->
  <el-carousel :interval="5000" arrow="always" :height="bannerHeight + 'px'">
    <el-carousel-item v-for="(item, index) in imageList" :key="index">
      <div class="image-contain" @click="blank_href(item.href)">
        <el-image class="elimage" :src="item.url" />
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import { getBannerList } from "@/api/banner"
export default {
  name: "Carousel",
  components: {},
  data () {
    return {
      imageList: [],
      bannerHeight: 0,
      screenWidth: 0,
    }
  },
  computed: {},
  mounted () {
    // 根据不同路由跳转不同页面
    if (this.getBrowserMobile()) {
      // 首次加载时,初始化高度
      this.screenWidth = window.innerWidth
      this.bannerHeight = 0.5 * this.screenWidth
      // 窗口大小发生改变
      window.onresize = () => {
        this.screenWidth = window.innerWidth
        this.bannerHeight = 0.5 * this.screenWidth
      }
    } else {
      // 首次加载时,初始化高度
      this.screenWidth = window.innerWidth
      this.bannerHeight = (400 / 1550) * this.screenWidth
      // 窗口大小发生改变
      window.onresize = () => {
        this.screenWidth = window.innerWidth
        this.bannerHeight = (400 / 1550) * this.screenWidth
      }
    }
    this.getListData()
  },
  methods: {
    // 判断浏览环境是手机端和pc端
    getBrowserMobile () {
      const regBrowser =
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      const flag = navigator.userAgent.match(regBrowser) ? true : false // 判断是否是手机浏览
      return flag
    },

    getListData () {
      this.imageList = []
      const params = { type: 1 }
      getBannerList(params).then((res) => {
        if (res.code === 0) {
          this.imageList = res.data?.map((item) => {
            return {
              url: item.url,
              href: item.href,
            }
          })
        }
      }).catch(() => { })
    },
    blank_href (item) {
      window.open(item, "_blank")
    },
  },
};
</script>
<style scoped lang="scss">
.image-contain {
  width: 100%;
  height: 100%;
  cursor: pointer;

  .elimage {
    width: 100%;
    height: inherit;
  }
}
</style>
